import { render, staticRenderFns } from "./HospitalEmails.vue?vue&type=template&id=748c876b&scoped=true&"
import script from "./HospitalEmails.vue?vue&type=script&lang=js&"
export * from "./HospitalEmails.vue?vue&type=script&lang=js&"
import style0 from "./HospitalEmails.vue?vue&type=style&index=0&id=748c876b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c876b",
  null
  
)

export default component.exports